import {
  Button,
  type ButtonProps,
  IconButton,
  type IconButtonProps,
  ListItemButton,
  MenuItem,
  type MenuItemProps,
  Link as MuiLink,
} from '@mui/material';
import { createLink, type CreateLinkProps } from '@tanstack/react-router';
import { forwardRef } from 'react';

export const ButtonLink = createLink(
  forwardRef<HTMLAnchorElement, CreateLinkProps & Omit<ButtonProps<'a'>, 'component'>>((props, ref) => (
    <Button {...props} ref={ref} component={MuiLink} nativeButton={false} />
  )),
);

export const IconButtonLink = createLink(
  forwardRef<HTMLAnchorElement, CreateLinkProps & Omit<IconButtonProps<'a'>, 'component'>>((props, ref) => (
    <IconButton {...props} ref={ref} component={MuiLink} nativeButton={false} />
  )),
);

export const MenuItemLink = createLink(
  forwardRef<HTMLAnchorElement, CreateLinkProps & Omit<MenuItemProps<'a'>, 'component'>>((props, ref) => (
    <MenuItem {...props} ref={ref} component={MuiLink} nativeButton={false} />
  )),
);

export const ListItemButtonLink = createLink(
  forwardRef<HTMLAnchorElement, CreateLinkProps & Omit<MenuItemProps<'a'>, 'component'>>((props, ref) => (
    <ListItemButton {...props} ref={ref} component={MuiLink} nativeButton={false} />
  )),
);

export const Link = createLink(MuiLink);
